export interface DeleteCollectionListRequest {
  id: number
  revision: number
}

export function DeleteCollectionListRequestToJSON(
  value: DeleteCollectionListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
